<style scoped lang="less">
/deep/ .el-tag {
	margin: 5px 1rem 5px 0;
}

.trainplantitle {
	display: flex;
	align-items: center;
	justify-content: space-around;
	background-color: #fff;

	padding: 1rem 0;
	margin-bottom: 1rem;
	div {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		font-size: 0.8rem;
		border-radius: 15px;

		p:first-child {
			font-size: 1rem;
			font-weight: 500;
		}

		p:last-child {
			font-size: 1.6rem;
			font-weight: 600;
		}
	}
}
.flexcenter {
	display: flex;
	align-items: center;
	justify-content: center;

	.tabsactives {
		border-color: #0079fe;
		color: #0079fe;
	}
}

.trainplancontent {
	background-color: #fff;
	width: 100%;
	padding: 2rem;
	.trainplantop {
		display: flex;
		align-items: center;
		justify-content: space-between;
		.tabsli {
			display: flex;
			align-items: center;
			width: 100%;

			overflow: hidden;

			.tabslisa {
				width: 20rem;

				div {
					width: 80px;
					height: 2rem;
					line-height: 2rem;
					border: 1px solid;
					text-align: center;
					cursor: pointer;
				}
				div:first-child {
					border-top-left-radius: 4px;
					border-bottom-left-radius: 4px;
					border-right: none;
				}

				div:last-child {
					border-top-right-radius: 4px;
					border-bottom-right-radius: 4px;
					border-left: none;
				}

				div:nth-of-type(2) {
					border-right: none;
				}
				div:nth-of-type(3) {
					border-right: none;
				}
			}
		}

		.trainsearch {
			display: flex;
			align-items: center;
			margin-left: 1rem;
			width: 26rem;
		}
	}

	.planlist {
		margin-top: 1rem;
		padding-bottom: 4rem;
		.planlistitem {
			display: flex;
			align-items: center;
			border-bottom: 1px solid #f2f2f2;
			padding: 1rem 0;
			.planlistitemuser {
				width: 25%;
				margin-right: 14px;
				justify-content: flex-start;
			}

			.planlispress {
				width: 30%;
				margin-right: 30px;
				.circle {
					display: block;
					width: 10px;
					height: 10px;
					background-color: #0079fe;
					border-radius: 50%;
					margin-right: 4px;
				}
			}

			.planlistimer {
				width: 20%;
				margin-left: 40px;
			}

			.planlisuserlist {
				width: 25%;
				height: 2rem;
				margin-right: 5%;
				display: flex;
				align-items: center;
				white-space: nowrap;
				overflow: scroll;

				/deep/ .switchStyle .el-switch__label {
					position: absolute;
					display: none;
					color: #ffffff;
				}

				/deep/ .switchStyle .el-switch__label--left {
					z-index: 9;
					left: 25px;
				}

				/deep/ .switchStyle .el-switch__label--right {
					z-index: 9;
					left: 0px;
					top: 0;
				}

				/deep/ .switchStyle .el-switch__label.is-active {
					display: block;
				}

				/deep/ .switchStyle.el-switch .el-switch__core,
				/deep/ .el-switch .el-switch__label {
					width: 100px !important;
				}
			}

			/* 滚动条整体 */
			.planlisuserlist::-webkit-scrollbar {
				height: 5px;
				width: 2px;
			}
			/* 两个滚动条交接处 -- x轴和y轴 */
			.planlisuserlist::-webkit-scrollbar-corner {
				background-color: transparent;
			}

			/* 滚动条滑块 */
			.planlisuserlist::-webkit-scrollbar-thumb {
				width: 5px;
				border-radius: 5px;
				-webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
				background: #0079fe;
			}

			/* 滚动条轨道 */
			.planlisuserlist::-webkit-scrollbar-track {
				-webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.2);
				border-radius: 5px;
				display: none;
				background: #ededed;
			}

			/* 滚动条两端按钮 */
			.planlisuserlist::-webkit-scrollbar-button {
			}

			.planlistoperate {
				width: 20%;
				display: flex;
				align-items: center;
				justify-content: flex-end;

				p {
					cursor: pointer;
					color: #0d6efd;
					font-size: 14px;
					margin-right: 10px;
					// text-decoration:underline  #0079fe;
				}
			}

			.planitemname {
				margin-left: 20px;

				p:first-child {
					font-size: 1rem;
					font-weight: 600;
					color: #666666;
				}
				p:last-child {
					color: #999999;
				}
			}
		}
	}
}

/deep/ .el-drawer__header {
	span {
		font-size: 1.2rem !important;
		font-weight: 600;
		color: #666666;
	}
}
.formaddtrainplan {
	padding: 0 1rem;
}

.colbtn {
	color: #0079fe;
	text-decoration: underline;
	cursor: pointer;
}

.scussesadd {
	color: #0079fe;
	font-size: 18px;
	margin-left: 20px;
	cursor: pointer;
}

/deep/ .el-select {
	margin: 0 1rem;
	height: 2rem;
	.el-input {
		height: 2rem;
		input {
			height: 100%;
		}
	}
}
.flexy {
	display: flex;
	flex-direction: column;
	align-items: center;
}
.userlistschoice {
	display: flex;
	align-items: center;
	justify-content: flex-start;
	width: 100%;
	flex-wrap: wrap;
}
/deep/ .cell {
	text-align: center;
	overflow: hidden; //超出的文本隐藏
	text-overflow: ellipsis; //溢出用省略号显示
	white-space: nowrap; //溢出不换行
}

.fontHead {
	min-width: 3rem;
	height: 3rem;
	line-height: 3rem;
	text-align: center;
	// border: 1px solid #222;
	font-size: 2rem;
	border-radius: 50%;
	font-weight: bold;
	color: #fff;
}
</style>
<template>
	<div>
		<titles titlename="实训计划管理" titlecontent="这里可以管理实训计划" :mbx="paths"></titles>
		<div class="trainplantitle">
			<div>
				<p>计划总数</p>
				<p>{{ statiicsobj.PlanTotal }}</p>
			</div>
			<div>
				<p>进行中</p>
				<p>{{ statiicsobj.PlanCarryout }}</p>
			</div>
			<div>
				<p>已延期</p>
				<p>{{ statiicsobj.PlanPostpone }}</p>
			</div>
			<div>
				<p>已完成</p>
				<p>{{ statiicsobj.PlanComplete }}</p>
			</div>
			<div>
				<p>已取消</p>
				<p>{{ statiicsobj.PlanCancel }}</p>
			</div>
		</div>

		<div class="trainplancontent">
			<div class="trainplantop">
				<div class="tabsli">
					<div class="flexcenter tabslisa">
						<div
							v-for="(item, index) in tabslist"
							@click="
								tabsactive = item.tabsid;
								changeplanmarge(item);
							"
							:class="{ tabsactives: tabsactive == item.tabsid }"
							:key="item.tabsid"
						>
							{{ item.tabsname }}
						</div>
					</div>
					<div class="trainsearch">
						<el-input style="height: 2rem;line-height: 2rem;" class="flexcenter" size="small" v-model="elinput" placeholder="请输入内容"></el-input>
						<el-button style="margin-left: 1rem;height: 2rem;line-height: 2rem;" class="flexcenter" type="primary" @click="tapplans()" icon="el-icon-search">
							查询
						</el-button>
						<el-button style="height: 2rem;line-height: 2rem;" class="flexcenter" icon="el-icon-refresh-left" @click="resolvelist">重置</el-button>
					</div>
				</div>
				<div class="addplans">
					<el-button type="primary" style="height: 2rem;line-height: 2rem;" class="flexcenter" icon="el-icon-plus" @click="addplans">添加计划</el-button>
				</div>
			</div>
			<div class="planlist">
				<el-empty v-if="planslist.length == 0" description="暂无计划,请添加并分配计划"></el-empty>

				<div class="planlistitem" v-for="(item, index) in planslist" :key="item.SP_GUID">
					<div class="planlistitemuser flexcenter">
						<!-- <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" /> -->
						<div class="fontHead" :style="randomRgb()">{{ item.SP_planName.slice(0, 1) }}</div>
						<div class="planitemname" style="margin-right: 10px;">
							<p style="width: 80%;">{{ item.SP_planName }}</p>
							<p class="nowrap" style="width: 80%;">{{ item.SP_planContent ?? '' }}</p>
						</div>
					</div>
					<div class="planlispress">
						<div class="flexcenter" style="color: #999; justify-content: space-between;margin-bottom: 10px;">
							<p>当前进度{{ item.Schedule }}%</p>
							<p class="flexcenter">
								<span
									class="circle"
									:style="{
										background:
											item.Status_ == '未开始'
												? '#ccc'
												: item.Status_ == '已延期' || item.Status_ == '已取消'
												? '#ec4e00'
												: item.Status_ == '已完成'
												? '#00CC77'
												: ''
									}"
								></span>
								{{ item.Status_ }}
							</p>
						</div>
						<el-progress :show-text="false" :color="customColors" :stroke-width="10" :percentage="item.Schedule"></el-progress>
					</div>
					<div class="planlistimer">
						<p>创建时间</p>
						<p>{{ item.CreatedTime }}</p>
					</div>
					<div class="planlisuserlist" style="width: 16%;">
						<el-switch
							style="display: block"
							v-model="item.EnableorNot"
							active-color="#00cc77"
							class="switchStyle"
							inactive-color="#F00000"
							active-text="计划启动中"
							inactive-text="计划禁用中"
							:active-value="1"
							:inactive-value="0"
							@change="switchChangeFin($event, item)"
						></el-switch>
						<!-- @change="switchChangeFin($event, item)" -->
						<!-- <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" />
                        <img src="@/images/header.png" alt="" style="width: 40px;height: 40px;border-radius: 50%;" /> -->
					</div>
					<div class="planlistoperate">
						<p @click="gopressxq(item)">
							<span class="el-icon-view"></span>
							查看
						</p>
						<p @click="editplans(item)">
							<span class="el-icon-edit-outline"></span>
							编辑
						</p>
						<p @click="deleteplansa(item)">
							<span class="el-icon-close"></span>
							删除
						</p>
					</div>
				</div>
			</div>

			<div class="flexcenter"><el-pagination background layout="prev, pager, next" :total="10"></el-pagination></div>
		</div>

		<el-drawer custom-class="eldrawesa" :title="plantitle" :visible.sync="drawer" size="40%" direction="rtl" :before-close="handleClose">
			<div class="formaddtrainplan">
				<el-form label-position="left" label-width="110px" :model="formLabelAlign">
					<el-form-item label="实训计划编号:"><el-input v-model="formLabelAlign.SP_planNumber" placeholder="请输入计划编号"></el-input></el-form-item>
					<el-form-item label="实训计划名称:"><el-input v-model="formLabelAlign.planname" placeholder="请输入计划名称"></el-input></el-form-item>
					<el-form-item label="截止完成时间:">
						<el-date-picker
							v-model="formLabelAlign.plantimer"
							type="datetime"
							style="width: 100%;"
							@change="changestimers()"
							:picker-options="{
								disabledDate: time => time.getTime() < Date.now() - 8.64e7
							}"
							placeholder="选择日期时间"
						></el-date-picker>
					</el-form-item>
					<el-form-item label="实训计划描述:"><el-input placeholder="请输入描述" v-model="formLabelAlign.plandescribe"></el-input></el-form-item>
					<el-form-item label="添加计划内容:" v-if="formLabelAlign.EnableorNot != 1">
						<el-button type="primary" style="height: 2rem;line-height: 2rem;" class="flexcenter" icon="el-icon-plus" @click="addexmine">添加计划内容</el-button>
					</el-form-item>
				</el-form>

				<div class="addplantable" v-if="formLabelAlign.EnableorNot != 1">
					<el-table :data="alleaxminsxlist" stripe style="width: 100%">
						<el-table-column type="index" :index="indexMethod" label="序号" width="50"></el-table-column>
						<el-table-column prop="PC_resourceType" label="类型"></el-table-column>
						<el-table-column label="名称">
							<template slot-scope="scope">
								{{ scope.row.PC_planContent }}
							</template>
						</el-table-column>
						<el-table-column prop="sort" label="排序">
							<template slot-scope="scope">
								<select v-model="scope.row.PC_sortCode" style="border: 1px solid #ccc;border-radius: 3px;">
									<option v-for="(ite, idx) in alleaxminsxlist">{{ idx + 1 }}</option>
								</select>
							</template>
						</el-table-column>
						<!-- <el-table-column label="权重值">
                            <template slot-scope="scope">
                                <div class="flexcenter" style="justify-content: flex-start;">
                                    <input v-model="scope.row.weighted" type="text" maxlength="3" style="width: 40%;border: 1px solid #ccc;margin-right: 5px;" />
                                    <span>%</span>
                                </div>
                            </template>
                        </el-table-column> -->
						<el-table-column label="截止日期" width="260">
							<template slot-scope="scope">
								<!-- <input
                                    v-model="scope.row.PC_indateDate"
                                    type="text"
                                    maxlength="3"
                                    style="width: 65%;border: 1px solid #ccc;margin-right: 5px;padding: 5px;border-radius: 8px;"
                                /> -->
								<el-date-picker
									style="width: 84%;"
									v-model="timerstable[scope.$index]"
									type="datetime"
									placeholder="选择日期时间"
									align="right"
									:picker-options="pickerOptions1"
								></el-date-picker>

								<!-- <el-date-picker :disabled="false"  :readonly="false"  v-model="scope.row.PC_indateDate" type="datetime" placeholder="选择日期时间"></el-date-picker> -->
							</template>
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<div class="flexcenter" style="justify-content: space-evenly;"><p class="colbtn" @click="deleteplans(scope.row)">删除</p></div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="addusers">
					<div class="flexcenter" style="justify-content: flex-start;margin: 1rem 0;">
						<p style="margin-top: 1rem;font-size: 1rem;color: #606266;">添加学习成员：</p>
						<p @click="adduserschioce" class="el-icon-circle-plus-outline" style="cursor: pointer;margin-top: 1rem;font-size: 30px;color: #409EFF;"></p>
					</div>
				</div>

				<div class="planlisuserlist" v-for="(ites, idxs) in choicelist" style="position: relative;  margin: 10px 0;display: inline-block;">
					<img
						:key="ites.ui_guid"
						:src="ites.ui_photoPath ? ites.ui_photoPath : userheast"
						style="z-index: 111;  width: 40px;height: 40px;border-radius: 50%;margin-right: 1rem;cursor: pointer;"
					/>
					<p style=" width: 36px;text-align: center;margin-top: 5px;">{{ ites.user ? ites.user.ui_realName : ites.ui_realName }}</p>
					<p
						@click="delectusers(ites)"
						class="bi bi-x-circle-fill"
						style="cursor: pointer;   position: absolute;color: red;top:-10px;right: 11%;z-index: 999999;font-size: 1rem;"
					></p>
				</div>

				<div class="flexcenter">
					<el-button type="info" @click="drawer = false">取消</el-button>
					<el-button type="primary" @click="addplanslist()">确定</el-button>
				</div>
			</div>
		</el-drawer>

		<el-dialog :title="addusertitle" :visible.sync="dialogVisible" width="50%" :before-close="handleClose">
			<div class="addcontent" v-if="isaddcontent == 1">
				<el-radio-group v-model="planradio" @change="changeradio">
					<el-radio :label="1">考试</el-radio>
					<el-radio :label="2">实训</el-radio>
				</el-radio-group>

				<div class="addusers" v-if="planradio == 1">
					<div class="flexy" style="justify-content: flex-start;margin: 1rem 0;align-items: flex-start;">
						<div class="flexcenter" style="margin: 1rem 0;width: 100%;" :style="{ 'justify-content': plantags.length == 0 ? 'flex-start' : '' }">
							<p style="font-size: 1rem;color: #606266;">所选试卷：</p>
							<div v-if="plantags.length > 0" class="choiceslist" style="border:1px solid #ccc;width: 85%;padding: 5px;border-radius: 5px;">
								<el-tag v-for="tag in plantags" @close="handleClosea(tag)" :key="tag.SPA_GUID" closable>{{ tag.SPA_PaperTitle }}</el-tag>
							</div>
						</div>
						<div class="tablesadd" style="width: 100%;overflow: hidden;">
							<div
								style="box-sizing: border-box;padding: 10px 0;  background-color: #F2F2F2;width: 100%;display: flex;align-items: center;justify-content: flex-end;"
							>
								<el-input
									style="width: 40%;margin-right: 10px;border-radius: 10px;"
									placeholder="请输入需要搜索的考试名称"
									v-model="searchexmain"
									clearable
									@input="inputsclectname()"
								></el-input>
							</div>
							<div>
								<el-table :data="examinetableData" style="width: 100%">
									<el-table-column prop="SPA_PaperTitle" title="SPA_PaperTitle" label="试卷名称">
										<template slot-scope="scope">
											<p :title="scope.row.SPA_PaperTitle">{{ scope.row.SPA_PaperTitle }}</p>
										</template>
									</el-table-column>
									<el-table-column prop="CA_CategoryName" label="专业"></el-table-column>
									<el-table-column prop="PR_ProfessionalName" label="所属岗位"></el-table-column>
									<el-table-column prop="IL_LevelTitle" label="等级"></el-table-column>
									<el-table-column label="操作" width="60">
										<template slot-scope="scope">
											<div class="flexcenter" style="justify-content: space-evenly;" @click="choiceexamen(scope.row)"><p class="colbtn">选择</p></div>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="flexcenter" style="margin-top: 1rem;">
								<el-pagination
									background
									layout="prev, pager, next"
									:total="allexminesize"
									:current-page.sync="exminepageidx"
									:page-size="exminepagepase"
									@size-change="handleSizeChange"
									@current-change="handleCurrentChange"
								></el-pagination>
							</div>
						</div>
					</div>
				</div>

				<div class="addusers" v-if="planradio == 2">
					<div class="flexy" style="justify-content: flex-start;margin: 1rem 0;align-items: flex-start;">
						<div class="flexcenter" style="margin: 1rem 0;width: 100%;" :style="{ 'justify-content': plantagsx.length == 0 ? 'flex-start' : '' }">
							<p style="font-size: 1rem;color: #606266;">所选实训：</p>
							<div v-if="plantagsx.length > 0" class="choiceslist" style="border:1px solid #ccc;width: 85%;padding: 5px;border-radius: 5px;">
								<el-tag v-for="tag in plantagsx" @close="handleClosea(tag)" :key="tag.pid" closable>{{ tag.projectName }}</el-tag>
							</div>
						</div>
						<div class="tablesadd" style="width: 100%;overflow: hidden;">
							<div style="box-sizing: border-box;padding: 5px 0;background-color: #4eea00;width: 100%;display: flex;align-items: center;justify-content: flex-end;">
								<!-- <el-input
                                    style="width: 40%;margin-right: 10px;border-radius: 10px;"
                                    placeholder="请输入需要搜索的考试名称"
                                    v-model="searchexmain"
                                    clearable
                                ></el-input> -->
							</div>
							<div>
								<el-table :data="examinetableData" style="width: 100%">
									<el-table-column prop="parentProjectName" label="所属能力类型" width="220"></el-table-column>
									<el-table-column prop="projectName" label="能力项目"></el-table-column>
									<el-table-column label="操作">
										<template slot-scope="scope">
											<div class="flexcenter" style="justify-content: space-evenly;" @click="choiceexamen(scope.row)">
												<p class="colbtn">{{ isddexmane }}</p>
											</div>
										</template>
									</el-table-column>
								</el-table>
							</div>
							<div class="flexcenter" style="margin-top: 1rem;justify-content: flex-end;">
								<p class="colbtn" @click="prepspages()" style="margin: 0 5px;">上一页</p>
								<p class="colbtn" @click="nextpages()" style="margin: 0 10px;">下一页</p>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="addusers" v-if="isaddcontent == 2">
				<div class="flexcenter" style="justify-content: flex-start;margin-bottom: 2rem;">
					<el-checkbox v-if="userlists.length > 0" label="全选" @change="handleCheckAllChange"></el-checkbox>
					<el-select v-model="addusersvalue" placeholder="请选择班级" @change="changeclassuser()">
						<el-option v-for="item in addusersoptions" :key="item.cla_guid" :label="item.cla_name" :value="item.cla_guid"></el-option>
					</el-select>
				</div>
				<div class="userlistschoice">
					<div
						v-for="(ite, indx) in userlists"
						:key="ite.ui_guid"
						class="flexy"
						@click.sync="choiceusers(ite, indx)"
						style="align-items: inherit;position: relative;width: 20%;margin: 10px 0;"
					>
						<img v-if="ite.isuserchoice" style="position: absolute;top: 0;width: 60px;height: 60px;border-radius: 5px;" src="@/images/choices.svg" alt="" />

						<img :src="ite.ui_photoPath ? ite.ui_photoPath : userheast" alt="" style="border-radius: 5px;width: 60px;height: 60px;" />
						<p style="margin-top: 5px;cursor: pointer;">{{ ite.ui_realName }}</p>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button
					type="primary"
					@click="
						contentscuss();
						addchangetime();
					"
				>
					确 定
				</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import titles from '@/components/title/title.vue';

import { getexminelist } from '@/request/api/pingtai/terrace';

import {
	changeDeletePlanUser,
	changeDeletePlan,
	gettrainlist,
	setAddstageplan,
	getplanPagelist,
	changeEnableorNot,
	getplanStatiics,
	getperuser,
	getputplan
} from '@/request/api/pingtai/trainsplan';

import { ClassInfoGetClassList } from '@/request/api/mange/mange';

import { GetdataClassStuinfoList } from '@/request/api/dataorder/dataprder';

import { uniqueFunc, changetimers } from '@/utils/utils';
import { array } from 'js-md5';

import AppOptions from '@/config/AppOptions.vue';

export default {
	data() {
		return {
			plantitle: '添加实训计划',
			ischoices: false,
			// 开关
			planwitch: true,
			// 用户列表
			userlist: [
				{
					username: '叶天',
					userimag: '@/images/choices.svg'
				}
			],
			// 弹窗
			addusertitle: '添加学生',
			dialogVisible: false,
			// 班级列表
			addusersvalue: '',
			addusersvalueid: '',
			addusersoptions: [],
			// 抽屉
			drawer: false,
			// 表单
			formLabelAlign: {
				SP_planNumber: '',
				planname: '',
				plantimer: new Date(),
				plandescribe: '',
				EnableorNot: ''
			},
			// 表格
			tableData: [
				{
					plantype: '试卷',
					planname: '理论考核',
					sort: '1',
					weighted: '10',
					expirydate: ''
				},
				{
					plantype: '试卷',
					planname: '理论考核',
					sort: '1',
					weighted: '10',
					expirydate: ''
				},
				{
					plantype: '试卷',
					planname: '理论考核',
					sort: '1',
					weighted: '10',
					expirydate: ''
				}
			],
			examinetableData: [],
			istables: false,
			// 标题
			paths: [
				{
					path: '/allmanage/trainspressmange',
					name: '实训计划管理'
				}
			],
			// 标签列表
			tabsactive: 'avca1',
			tabslist: [
				{
					tabsid: 'avca1',
					tabsname: '全部'
				},
				{
					tabsid: 'avca2',
					tabsname: '进行中'
				},
				{
					tabsid: 'avca3',
					tabsname: '已延期'
				},
				{
					tabsid: 'avca4',
					tabsname: '已完成'
				},
				{
					tabsid: 'avca5',
					tabsname: '已取消'
				}
			],
			// 搜索输入
			elinput: '',
			// 判断是添加内容还是添加学习成员
			isaddcontent: 1,
			planradio: 1,
			// 标签栏
			plantags: [],
			searchexmain: '',
			// 获取计划内容
			exminepageidx: 1,
			exminepagepase: 10,
			allexminesize: 0,
			isddexmane: '选择',
			isaddexmina: {},
			// 总数组记录试卷或者考试
			alleaxminsxlist: [],
			examinetablepase: 0,
			// tag实训
			plantagsx: [],
			// 用户列表
			userlists: [],
			// 图片获取
			userheast: require('@/images/header.png'),
			choiceusersitem: {},
			bleameslist: [],
			// 选择成员
			choicelist: [],
			pickerOptions: {
				shortcuts: [
					{
						text: '今天',
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					},
					{
						text: '一周后',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					},
					{
						text: '一个月后',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 30);
							picker.$emit('pick', date);
						}
					},
					{
						text: '三个月后',
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() + 3600 * 1000 * 24 * 90);
							picker.$emit('pick', date);
						}
					}
				]
			},
			// 获取计划列表
			getplans: {
				pageIndex: 1,
				pageSize: 10,
				status: '',
				name: ''
			},
			planslist: [],
			// 统计对象
			statiicsobj: {},
			timerstable: [],
			customColors: [
				{ color: '#f56c6c', percentage: 20 },
				{ color: '#e6a23c', percentage: 40 },
				{ color: '#1989fa', percentage: 60 },
				{ color: '#6f7ad3', percentage: 80 },
				{ color: '#5cb87a', percentage: 100 }
			]
		};
	},
	computed: {
		pickerOptions1() {
			return {
				disabledDate: time => {
					return time.getTime() > new Date(this.formLabelAlign.plantimer).getTime(); // 将大于最大值的日期设为不可选
				}
			};
		}
	},
	watch: {},
	mounted() {
		this.getplanPagelists();
	},
	updated() {
		// console.log(this.choicelist)
	},
	created() {
		AppOptions.appEmpty = false;
	},
	methods: {
		//添加计划内容时修改时间
		addchangetime() {
			if (this.formLabelAlign.plantimer) {
				let timerstable = [];
				this.timerstable.forEach(item => {
					timerstable.push(this.formLabelAlign.plantimer);
				});
				this.timerstable = timerstable;
			}
		},
		// 删除学习成员
		delectusers(itm) {
			if (this.formLabelAlign.EnableorNot != 1) {
				// 添加删除成员
				this.choicelist.splice(this.choicelist.indexOf(itm), 1);
			} else {
				// 编辑删除成员
				this.$confirm('此操作将删除这个学员的实训信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				})
					.then(() => {
						this.changeplansjh(itm);
						this.choicelist.splice(this.choicelist.indexOf(itm), 1);
					})
					.catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
			}
		},
		// 删除计划成员
		changeplansjh(ite) {
			let planUserobj = {
				SP_GUID: ite.SP_GUID,
				UI_GUID: ite.UI_GUID
			};

			changeDeletePlanUser(planUserobj).then(res => {
				if (res.data.code > 0) {
					this.$message.success(res.data.msg);
				} else {
					this.$message(res.data.msg);
				}
			});
		},
		// 更改时间联动选择专业时间
		changestimers() {
			// console.log(this.formLabelAlign.plantimer)
			if (this.timerstable.length > 0) {
				let timerstable = [];
				this.timerstable.forEach(item => {
					timerstable.push(this.formLabelAlign.plantimer);
				});
				this.timerstable = timerstable;
				// console.log(this.timerstable)
			}
		},
		randomRgb(item) {
			let R = Math.floor(Math.random() * 130 + 110);
			let G = Math.floor(Math.random() * 130 + 110);
			let B = Math.floor(Math.random() * 130 + 110);
			//console.log(R,G,B)
			return {
				background: 'rgb(' + R + ',' + G + ',' + B + ', .5)'
			};
		},

		// 获取实训计划列表
		getplanPagelists() {
			getplanPagelist(this.getplans).then(res => {
				this.planslist = res.data.data.list;
				this.planslist.forEach(item => {
					item.CreatedTime = item.CreatedTime.replace('T', ' ');
				});
				this.getstuice();
				// console.log('planslist===========>', this.planslist);
			});
		},
		// 获取统计
		getstuice() {
			getplanStatiics().then(res => {
				this.statiicsobj = res.data.data.list;
			});
		},

		// 删除计划
		deleteplansa(ite) {
			this.$confirm('此操作将删除改计划所有学员的实训信息, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					this.deleteplansb(ite);
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		deleteplansb(itm) {
			// console.log(itm)
			let deleplans = {
				SP_GUID: itm.SP_GUID
			};
			changeDeletePlan(deleplans).then(res => {
				if (res.data.code == 1) {
					this.getplanPagelists();
					this.$message.success(res.data.msg);
					return;
				}
				this.$message(res.data.msg);
			});
		},
		gopressxq(item) {
			this.$router.push({
				path: '/allmanage/trainspressmangexq?spguid=' + item.SP_GUID
			});
		},
		// 编辑计划
		editplans(item) {
			let isfromedit = JSON.parse(JSON.stringify(item));
			if (item.Status_ == '已完成' || item.Status_ == '已取消') {
				this.$message('当前计划已完成或已取消无法修改');
				return;
			}
			this.plantitle = '编辑计划';
			// console.log('item》》》》》', item);

			if (item.EnableorNot == 0) {
				this.drawer = true;
				this.formLabelAlign.SP_planNumber = isfromedit.SP_planNumber;
				this.formLabelAlign.planname = isfromedit.SP_planName;
				this.formLabelAlign.plantimer = isfromedit.SP_indateDate;
				this.formLabelAlign.plandescribe = isfromedit.SP_planContent;
				this.formLabelAlign.EnableorNot = 1;
				this.choicelist = isfromedit.sx_Learnorstudents;
				this.formLabelAlign.SP_GUID = isfromedit.SP_GUID;

				// console.log('isfromedit.sx_Learnorstudents》》》》》', isfromedit.sx_Learnorstudents);
			} else {
				this.$message('请关闭当前计划');
			}
		},
		// 更改班级
		changeclassuser() {
			// console.log(this.addusersvalue)
			this.addusersvalueid = this.addusersvalue;
			this.getclassuserlist();
		},
		// 分隔器
		group(array, subNum) {
			let index = 0;
			let newArray = [];
			while (index < array.length) {
				newArray.push(array.slice(index, (index += subNum)));
			}
			return newArray;
		},
		// 分页器
		handleSizeChange(val) {
			// console.log(`每页 ${val} 条`);
		},
		handleCurrentChange(val) {
			// console.log(`当前页: ${val}`);
			this.exminepageidx = val;
			let datas = {
				Pageindex: this.exminepageidx,
				PageSize: this.exminepagepase,
				SPA_PaperTitle: this.searchexmain
			};

			if (this.planradio == 1) {
				this.getexminelistsq(datas);
			} else {
				this.gettrainlistsq();
			}
		},

		// 添加计划列表
		addplanslist() {
			// this.drawer = false;
			let sLearnorstudents = [];
			let plancontentlist = [];

			if (this.formLabelAlign.SP_planNumber == '') {
				this.$message('请输入计划编号');
				return;
			}

			if (this.formLabelAlign.planname == '') {
				this.$message('请输入计划名称');
				return;
			}

			if (this.formLabelAlign.plandescribe == '') {
				this.$message('请输入计划描述');
				return;
			}

			if (this.choicelist.length == 0) {
				this.$message('请选择学生');
				return;
			}

			if (this.alleaxminsxlist.length == 0 && this.formLabelAlign.EnableorNot !== 1) {
				this.$message('请选择计划内容');
				return;
			}

			if (this.formLabelAlign.EnableorNot == 1) {
				// console.log(!this.formLabelAlign.plantimer.indexOf("T") == -1)

				try {
					this.formLabelAlign.plantimer = this.formLabelAlign.plantimer.replace('T', ' ');
				} catch {
					this.formLabelAlign.plantimer = changetimers(this.formLabelAlign.plantimer);
				}

				let putplans = {
					SP_planName: this.formLabelAlign.planname,
					SP_planNumber: this.formLabelAlign.SP_planNumber,
					SP_planContent: this.formLabelAlign.plandescribe,
					SP_indateDate: this.formLabelAlign.plantimer,
					SP_GUID: this.formLabelAlign.SP_GUID
				};
				// console.log(putplans)
				// return
				getputplan(putplans).then(res => {
					if (res.data.code == 1) {
						this.$message.success(res.data.msg);
						this.formLabelAlign.SP_planNumber = '';
						this.formLabelAlign.planname = '';
						this.formLabelAlign.plandescribe = '';
						this.formLabelAlign.plantimer = '';
						this.choicelist = [];
						this.alleaxminsxlist = [];
						this.drawer = false;
						this.dialogVisible = false;
						this.getplanPagelists();
					} else {
						this.$message(res.data.msg);
					}
				});
				return;
			}

			this.choicelist.forEach((ite, idx) => {
				sLearnorstudents.push({
					UI_GUID: ite.ui_guid ?? ite.UI_GUID,
					ui_photoPath: ite.ui_photoPath ?? ''
				});
			});

			// sLearnorstudents =  this.choicelist

			this.alleaxminsxlist.forEach((ites, idxs) => {
				try {
					let timertableserr = changetimers(this.timerstable[idxs]);
				} catch {
					this.$message('请选择内容截止时间');
				}

				plancontentlist.push({
					PC_planContent: ites.PC_planContent,
					PC_resourceType: ites.PC_resourceType,
					PC_planDescribe: ites.PC_planDescribe,
					PC_sortCode: ites.PC_sortCode,
					ZY_GUID: ites.ZY_GUID,
					PC_planWeight: ites.PC_planWeight,
					PC_indateDate: changetimers(this.timerstable[idxs])
				});
			});
			let dstageplan = {
				SP_planName: this.formLabelAlign.planname,
				SP_planNumber: this.formLabelAlign.SP_planNumber,
				UI_GUID: localStorage.getItem('uiguid'),
				SP_planContent: this.formLabelAlign.plandescribe,
				SP_indateDate: changetimers(this.formLabelAlign.plantimer),
				sx_Learnorstudents: sLearnorstudents,
				plancontentlist: plancontentlist
			};
			// console.log('dstageplan==========>',plancontentlist)

			setAddstageplan(dstageplan).then(res => {
				// console.log(res,"添加计划")
				if (res.data.code == 1) {
					this.formLabelAlign.SP_planNumber = '';
					this.formLabelAlign.planname = '';
					this.formLabelAlign.plandescribe = '';
					this.formLabelAlign.plantimer = '';
					this.choicelist = [];
					this.alleaxminsxlist = [];
					this.drawer = false;
					this.dialogVisible = false;
					this.getplanPagelists();
				}

				this.$message.success(res.data.msg);
			});
			// console.log(dstageplan);
		},

		handleCheckAllChange(e) {
			// 全选列表
			// console.log(e)
			this.ischoices = e;
			let userlist = Array.from(this.userlists);
			if (e) {
				userlist.forEach(item => {
					item.isuserchoice = true;
				});

				this.userlists = userlist;
			} else {
				userlist.forEach(item => {
					item.isuserchoice = false;
				});

				this.userlists = userlist;
			}
		},
		// 删除计划
		deleteplans(obj) {
			// console.log(obj)
			this.alleaxminsxlist.splice(this.alleaxminsxlist.indexOf(obj), 1);
			if (obj.PC_resourceType == '考试') {
				this.plantags = this.deleteElementById(this.plantags, obj.ZY_GUID);
			} else {
				this.plantagsx = this.deleteElementById(this.plantagsx, obj.ZY_GUID);
			}
		},
		deleteElementById(arr, id) {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i].ZY_GUID === id) {
					arr.splice(i, 1);
					break;
				}
			}
			return arr;
		},
		// 开关
		switchChangeFin(e, obj) {
			// console.log(e,obj)
			let dataswitme = {
				SP_GUID: obj.SP_GUID,
				Enable: e
			};
			changeEnableorNot(dataswitme).then(res => {
				if (res.data.code == 1) {
					this.$message.success(res.data.msg);
				} else {
					this.$message(res.data.msg);
					this.planslist.forEach(item => {
						if (item.SP_GUID == obj.SP_GUID) {
							item.EnableorNot = 0;
						}
					});
				}
			});
		},
		adduserschioce() {
			this.addusertitle = '添加学习成员';
			this.isaddcontent = 2;
			let siguid = localStorage.getItem('siguid');
			ClassInfoGetClassList(siguid).then(res => {
				//console.log('adduserschioce===============>',res)
				this.addusersoptions = res.data.data;
				this.addusersvalue = res.data.data[0].cla_name;
				this.addusersvalueid = res.data.data[0].cla_guid;
				this.getclassuserlist();
			});
			// 添加学习成员
			// https://www.hngtsd.net:444/api/Chart/GetClassStuinfoList?cla_guid=42d1766e77a245868ff36186e4daf458&ui_realName=
			this.dialogVisible = true;
		},
		getclassuserlist() {
			let datas = {
				cla_guid: this.addusersvalueid,
				ui_realName: ''
			};
			GetdataClassStuinfoList(datas).then(res => {
				//console.log('GetdataClassStuinfoList==========>', res);
				this.userlists = res.data.data;
				console.log('this.userlists000001=============>', this.userlists);
				this.userlists.forEach(item => {
					this.choicelist.forEach(ite => {
						// console.log("没有等于的嘛",item.ui_guid,ite.ui_guid)
						if (item.ui_guid == ite.UI_GUID || item.ui_guid == ite.ui_guid) {
							item.isuserchoice = true;
							// console.log("没有等于的嘛",item.ui_guid,ite.UI_GUID)
						}
					});
					//item.isuserchoice = false;
				});
				//console.log('this.userlists000002=============>', this.userlists);
				// 编辑回显
				if (this.formLabelAlign.EnableorNot == 1) {
					this.userlists.forEach(item => {
						this.choicelist.forEach(ite => {
							// console.log("没有等于的嘛",item.ui_guid,ite.ui_guid)
							if (item.ui_guid == ite.UI_GUID || item.ui_guid == ite.ui_guid) {
								item.isuserchoice = true;
								// console.log("没有等于的嘛",item.ui_guid,ite.UI_GUID)
							}
						});
					});

					//console.log(this.choicelist, '编辑回显');
				}
			});
		},
		// index值
		indexMethod(index) {
			return index + 1;
		},
		changeplanmarge(itm) {
			// 改变计划
			// console.log(itm)
			// if(itm.tabsname == '全部') itm.tabsname = ""
			this.getplans.status = itm.tabsname == '全部' ? '' : itm.tabsname;
			this.getplanPagelists();
		},
		tapplans() {
			// this.elinput获取计划列表
			this.getplans.name = this.elinput;
			this.getplanPagelists();
		},
		resolvelist() {
			// 重置列表
			this.getplans.status = '';
			this.getplans.name = '';
			this.getplans.pageIndex = 1;
			this.getplans.pageSize = 10;
			this.tabsactive = 'avca1';
			this.elinput = '';
			this.getplanPagelists();
		},
		addplans() {
			this.plantagsx = [];
			this.plantags = [];
			this.choicelist = [];
			this.plantitle = '添加实训计划';
			this.formLabelAlign.EnableorNot = '';
			this.formLabelAlign.SP_planNumber = '';
			this.formLabelAlign.planname = '';
			this.formLabelAlign.plantimer = '';
			this.formLabelAlign.plandescribe = '';
			this.formLabelAlign.EnableorNot = '';
			// 添加计划
			this.drawer = true;
		},
		// 点击外部关闭
		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		// 添加计划
		addexmine() {
			this.addusertitle = '添加计划内容';
			this.isaddcontent = 1;
			this.dialogVisible = true;

			// this.alleaxminsxlist = []

			// console.log(this.alleaxminsxlist,this.plantagsx,this.plantags)

			let datas = {
				Pageindex: this.exminepageidx,
				PageSize: this.exminepagepase,
				SPA_PaperTitle: this.searchexmain
			};
			if (this.planradio == 1) {
				this.getexminelistsq(datas);
			} else {
				this.gettrainlistsq();
			}

			//console.log('datas=====>',datas);
		},
		// 获取能力模型
		gettrainlistsq() {
			gettrainlist().then(res => {
				this.examinetableData = this.group(res.data.data.list, 5)[this.examinetablepase];
				// console.log(this.examinetableData)
				this.examinlisttables = this.group(res.data.data.list, 5);
			});
		},
		getexminelistsq(datas) {
			getexminelist(datas).then(res => {
				this.examinetableData = res.data.data.list;
				this.allexminesize = res.data.data.totalCount;
				//console.log('this.examinetableData==============>',this.examinetableData);
				//console.log('this.allexminesize==============>',this.allexminesize);
			});
		},

		// 切换当选框
		changeradio(e) {
			// console.log(e);

			this.exminepageidx = 1;
			this.exminepagepase = 10;
			let datas = {
				Pageindex: this.exminepageidx,
				PageSize: this.exminepagepase,
				SPA_PaperTitle: this.searchexmain
			};
			this.examinetableData = [];
			if (this.planradio == 1) {
				this.getexminelistsq(datas);
			} else {
				this.gettrainlistsq();
			}
		},
		// 选择试卷
		choiceexamen(obj) {
			if (this.planradio == 1) {
				obj.PC_resourceType = '考试';
				obj.PC_planContent = obj.SPA_PaperTitle;
				obj.PC_planDescribe = '';
				obj.PC_sortCode = '1';
				obj.ZY_GUID = obj.SPA_GUID;
				obj.PC_planWeight = '';
				obj.PC_indateDate = changetimers(new Date());

				this.plantags.push(obj);
				this.plantags = uniqueFunc(this.plantags, 'SPA_GUID');
			} else {
				obj.PC_resourceType = '实训';
				obj.PC_planContent = obj.projectName;
				obj.PC_planDescribe = '';
				obj.PC_sortCode = '1';
				obj.ZY_GUID = obj.pid;
				obj.PC_planWeight = '';
				obj.PC_indateDate = changetimers(new Date());
				this.plantagsx.push(obj);
				this.plantagsx = uniqueFunc(this.plantagsx, 'pid');
				// console.log(this.plantagsx)
			}
		},
		// 查询试卷或者实训
		inputsclectname() {
			let datas = {
				Pageindex: this.exminepageidx,
				PageSize: this.exminepagepase,
				SPA_PaperTitle: this.searchexmain
			};
			if (this.planradio == 1) {
				this.getexminelistsq(datas);
			} else {
				this.gettrainlistsq();
			}
		},
		handleClosea(tag) {
			// 删除标签
			if (this.planradio == 1) {
				this.plantags.splice(this.plantags.indexOf(tag), 1);
			} else {
				this.plantagsx.splice(this.plantagsx.indexOf(tag), 1);
			}
		},
		// 上一页下一页
		nextpages() {
			if (this.examinetablepase < this.examinlisttables.length) {
				this.examinetablepase += 1;
				this.examinetableData = this.examinlisttables[this.examinetablepase];
			}
		},
		prepspages() {
			if (this.examinetablepase > 0) {
				this.examinetablepase -= 1;
				this.examinetableData = this.examinlisttables[this.examinetablepase];
			}
		},
		// 确定添加内容
		contentscuss() {
			if (this.isaddcontent == 1) {
				this.alleaxminsxlist = [...this.plantagsx, ...this.plantags];
				this.alleaxminsxlist = uniqueFunc(this.alleaxminsxlist, 'ZY_GUID');

				this.alleaxminsxlist.forEach((item, index) => {
					item.PC_sortCode = index + 1;
					this.timerstable.push(new Date());
				});

				// console.log("timerstable》》》》》》》",this.timerstable)
				//console.log("alleaxminsxlist》》》》》》》》》",this.alleaxminsxlist)
				this.dialogVisible = false;
			} else {
				//console.log(this.userlists,"获取列表")

				let choicelist = [];
				if (this.choicelist.length > 0) {
					choicelist = this.choicelist;
				}

				this.userlists.forEach(its => {
					if (its.isuserchoice) {
						its.UI_GUID = its.ui_guid;
						choicelist.push(its);
					}
				});

				//console.log('this.userlists11111111========>', this.userlists);

				// 编辑回显
				if (this.formLabelAlign.EnableorNot == 1) {
					let uiguidlist = [];
					choicelist.forEach(itemsw => {
						if (itemsw.isuserchoice) {
							uiguidlist.push({
								UI_GUID: itemsw.ui_guid ?? itemsw.UI_GUID,
								SP_GUID: this.formLabelAlign.SP_GUID
							});
						}
					});
					uiguidlist = uniqueFunc(uiguidlist, 'UI_GUID');
					//console.log('choicelist==========>', choicelist);

					this.choicelist = uniqueFunc(choicelist, 'UI_GUID');
					this.choicelist.forEach(itees => {
						if (!itees.user) {
							// console.log("取items》》》",itees)
							itees.user = {};
							itees.user.ui_photoPath = itees.ui_photoPath;
							itees.user.ui_realName = itees.ui_realName;
						}
					});
					//console.log('this.choicelist==========>', this.choicelist);
					// return
					getperuser(uiguidlist).then(res => {
						if (res.data.code == 1) {
							this.$message.success(res.data.msg);
						} else {
							this.$message(res.data.msg);
						}
					});
				} else {
					this.choicelist = uniqueFunc(choicelist, 'ui_guid');
					//console.log('this.choicelist222222====>',this.choicelist)
				}
				this.dialogVisible = false;
			}
		},
		// 选择学生
		choiceusers(ite, idx) {
			let userlist = Array.from(this.userlists);
			userlist.forEach(items => {
				if (items.ui_guid == ite.ui_guid) {
					items.isuserchoice = !ite.isuserchoice;
				}
			});
			this.userlists = userlist;
			console.log('choiceusers.userlists========>', this.userlists);
		}
	},
	components: {
		titles
	}
};
</script>
